"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var uuid = require("uuid");
var sjcl = require("sjcl");
var utils_1 = require("./utils");
var aws_workdocs_web_client_common_1 = require("@amzn/aws-workdocs-web-client-common");
var axios_1 = require("axios");
var EncryptionService_1 = require("../services/EncryptionService");
var ConnectionPersistenceService_1 = require("../services/ConnectionPersistenceService");
var HttpChannel = (function () {
    function HttpChannel(companionConfig, logger, metricService) {
        this.clientType = 'HTTP';
        this.companionConfig = companionConfig;
        this.logger = logger;
        this.metricService = metricService;
    }
    HttpChannel.prototype.wasConnectedByQuickHandshake = function () {
        return this.lastSucceededHandshakeMethod === 'QUICK';
    };
    HttpChannel.prototype.getLastSucceededHandshakeMethod = function () {
        return this.lastSucceededHandshakeMethod;
    };
    HttpChannel.prototype.getCompanionVersion = function () {
        return this.companionVersion;
    };
    HttpChannel.prototype.connect = function (config) {
        var _this = this;
        if (!!this.pendingConnectPromise) {
            return this.pendingConnectPromise;
        }
        if (config.handshakeMethods.length < 1) {
            throw Error('There need to be at least one handshake method for making connection');
        }
        this.pendingConnectPromise = (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, handshakeErrorReasons, i, method, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(config.forcePortScan || !this.httpClient)) return [3, 2];
                        _a = this;
                        return [4, this.createHttpClient()];
                    case 1:
                        _a.httpClient = _b.sent();
                        _b.label = 2;
                    case 2:
                        handshakeErrorReasons = '';
                        i = 0;
                        _b.label = 3;
                    case 3:
                        if (!(i < config.handshakeMethods.length)) return [3, 13];
                        method = config.handshakeMethods[i];
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 11, , 12]);
                        if (!(method === 'COOKIE')) return [3, 6];
                        return [4, this.cookieHandshake()];
                    case 5:
                        _b.sent();
                        this.metricService.newCounterMetric('http_cookie_handshake_succeeded');
                        return [3, 13];
                    case 6:
                        if (!(method === 'QUICK')) return [3, 8];
                        return [4, this.quickHandshake()];
                    case 7:
                        _b.sent();
                        this.metricService.newCounterMetric('http_quick_handshake_succeeded');
                        return [3, 13];
                    case 8:
                        if (!(method === 'CLIPBOARD')) return [3, 10];
                        return [4, this.clipboardHandshake()];
                    case 9:
                        _b.sent();
                        this.metricService.newCounterMetric('http_clipboard_handshake_succeeded');
                        return [3, 13];
                    case 10: return [3, 12];
                    case 11:
                        error_1 = _b.sent();
                        handshakeErrorReasons = handshakeErrorReasons.concat(" " + method + ": " + error_1.message);
                        switch (method) {
                            case 'COOKIE':
                                this.metricService.newCounterMetric('http_cookie_handshake_failed');
                                break;
                            case 'QUICK':
                                this.metricService.newCounterMetric('http_quick_handshake_failed');
                                break;
                            case 'CLIPBOARD':
                                this.metricService.newCounterMetric('http_clipboard_handshake_failed');
                                break;
                            default:
                                break;
                        }
                        if (i === config.handshakeMethods.length - 1) {
                            throw Error('[HTTP] connect failed because:' + handshakeErrorReasons);
                        }
                        return [3, 12];
                    case 12:
                        i++;
                        return [3, 3];
                    case 13: return [4, this.setConfiguration()];
                    case 14:
                        _b.sent();
                        return [2];
                }
            });
        }); })();
        this.pendingConnectPromise.then(function () {
            _this.pendingConnectPromise = null;
        }, function () {
            _this.pendingConnectPromise = null;
        });
        return this.pendingConnectPromise;
    };
    HttpChannel.prototype.sendRequest = function (request) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var secureRequest, requestID, requestMessage, requestWithId, connectionInfo, response, responseMessage, tokenInfo, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        secureRequest = utils_1.isSecureOperation(request);
                        if (!(this.pendingConnectPromise && !utils_1.isRequestPartOfConnectProcess(request))) return [3, 2];
                        return [4, this.pendingConnectPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!!this.httpClient) return [3, 4];
                        requestID = utils_1.generateNewRequestID();
                        requestMessage = void 0;
                        requestWithId = tslib_1.__assign(tslib_1.__assign({}, request), { RequestID: requestID });
                        if (secureRequest) {
                            connectionInfo = ConnectionPersistenceService_1.getConnectionInfo(this.companionConfig.userID);
                            requestWithId.Parameters = tslib_1.__assign(tslib_1.__assign({}, requestWithId.Parameters), { connectionToken: connectionInfo.connectionToken });
                            requestMessage = JSON.stringify({
                                ConnectionToken: connectionInfo.connectionToken,
                                RequestData: EncryptionService_1.encrypt(JSON.stringify(requestWithId), connectionInfo.cryptoKey),
                            });
                        }
                        else {
                            requestMessage = JSON.stringify(requestWithId);
                        }
                        return [4, this.httpClient({ method: 'POST', data: requestMessage })];
                    case 3:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (secureRequest) {
                            tokenInfo = ConnectionPersistenceService_1.getConnectionInfo(this.companionConfig.userID);
                            responseMessage = EncryptionService_1.decrypt(responseMessage, tokenInfo.cryptoKey);
                        }
                        result = JSON.parse(responseMessage);
                        if (utils_1.isExceptionalResponse(result)) {
                            this.metricService.newCounterMetric('WorkDocs_Companion_Request_Sent_Count');
                            this.logger.error('[HTTP CHANNEL] Receive error response for action: ' + request.Operation + ': ' + result.ExceptionMessage);
                        }
                        return [2, result];
                    case 4: throw new Error('Cannot send request because there is no http client');
                }
            });
        });
    };
    HttpChannel.prototype.setConfiguration = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var setConfigurationRequest, setConfigurationResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setConfigurationRequest = {
                            Operation: 'SetConfiguration',
                            Parameters: this.companionConfig,
                        };
                        return [4, this.sendRequest(setConfigurationRequest)];
                    case 1:
                        setConfigurationResponse = _a.sent();
                        return [2, setConfigurationResponse.Result];
                }
            });
        });
    };
    HttpChannel.prototype.cookieHandshake = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var connId, cryptoKey, cookieHandshakeResponse, nConnectionToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connId = uuid.v1();
                        cryptoKey = sjcl.random.randomWords(8, 6);
                        utils_1.setKeyExchangeCookie(connId, cryptoKey);
                        return [4, this.sendRequest({
                                AuthenticationOperation: 'Connect',
                                AuthenticationParameters: {
                                    connectionToken: null,
                                    browserName: aws_workdocs_web_client_common_1.BrowserService.getBrowser(),
                                    browserVersion: aws_workdocs_web_client_common_1.BrowserService.getBrowserVersion(),
                                    cookieDomain: window.location.hostname,
                                    cookieName: utils_1.KEY_EXCHANGE_COOKIE_NAME,
                                    connectionID: connId,
                                    cookieConfigurationJson: null,
                                },
                            })];
                    case 1:
                        cookieHandshakeResponse = _a.sent();
                        this.logger.debug('[HTTP Channel] Got data for Connect response ' + JSON.stringify(cookieHandshakeResponse));
                        nConnectionToken = EncryptionService_1.decrypt(cookieHandshakeResponse.nConnectionToken, cryptoKey);
                        if (nConnectionToken === cookieHandshakeResponse.ConnectionToken) {
                            this.lastSucceededHandshakeMethod = 'COOKIE';
                            this.companionVersion = cookieHandshakeResponse.ApplicationVersion;
                            ConnectionPersistenceService_1.setConnectionInfo(this.companionConfig.userID, { connectionToken: cookieHandshakeResponse.ConnectionToken, cryptoKey: cryptoKey });
                        }
                        else {
                            throw new Error('Cookie handshake failed on URL ' + this.httpClient.defaults.baseURL + ' due to mismatch in nConnectionToken ');
                        }
                        return [2];
                }
            });
        });
    };
    HttpChannel.prototype.quickHandshake = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tokenInfo, cryptoKey, connectionToken, newCryptoKey, quickHandshakeResponse, nConnectionToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenInfo = ConnectionPersistenceService_1.getConnectionInfo(this.companionConfig.userID);
                        cryptoKey = tokenInfo.cryptoKey;
                        connectionToken = tokenInfo.connectionToken;
                        newCryptoKey = cryptoKey;
                        return [4, this.sendRequest({
                                AuthenticationOperation: 'Reconnect',
                                AuthenticationParameters: {
                                    connectionToken: connectionToken,
                                    nConnectionToken: EncryptionService_1.encrypt(connectionToken, cryptoKey),
                                    nNewEncryptionKey: EncryptionService_1.encrypt(sjcl.codec.base64.fromBits(newCryptoKey), cryptoKey),
                                },
                            })];
                    case 1:
                        quickHandshakeResponse = _a.sent();
                        this.logger.debug('[HTTP Channel] Got data for Connect response ' + JSON.stringify(quickHandshakeResponse));
                        nConnectionToken = EncryptionService_1.decrypt(quickHandshakeResponse.nConnectionToken, cryptoKey);
                        if (nConnectionToken === quickHandshakeResponse.ConnectionToken) {
                            this.lastSucceededHandshakeMethod = 'QUICK';
                            this.companionVersion = quickHandshakeResponse.ApplicationVersion;
                            ConnectionPersistenceService_1.setConnectionInfo(this.companionConfig.userID, { connectionToken: quickHandshakeResponse.ConnectionToken, cryptoKey: newCryptoKey });
                        }
                        else {
                            throw new Error('[HTTP CHANNEL] Quick handshake failed on URL ' + this.httpClient.defaults.baseURL + ' due to mismatch in nConnectionToken ');
                        }
                        return [2];
                }
            });
        });
    };
    HttpChannel.prototype.clipboardHandshake = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var connId, cryptoKey, error_2, clipboardHandshakeResponse, nConnectionToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connId = uuid.v1();
                        cryptoKey = sjcl.random.randomWords(8, 6);
                        if (!!aws_workdocs_web_client_common_1.BrowserService.isFireFox()) return [3, 2];
                        return [4, this.sendRequest({ Operation: 'SaveClipboard', Parameters: {} })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, utils_1.setKeyExchangeInfoToClipboard(connId, cryptoKey, this.metricService)];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        error_2 = _a.sent();
                        this.logger.error('failed to set key exchange info to clipboard', error_2);
                        throw Error('Clipboard handshake failed because it cannot save content to clipboard');
                    case 5: return [4, this.sendRequest({
                            AuthenticationOperation: 'ConnectByClipboard',
                            AuthenticationParameters: {
                                connectionToken: null,
                                connectionID: connId,
                            },
                        })];
                    case 6:
                        clipboardHandshakeResponse = _a.sent();
                        this.logger.debug('[HTTP Channel] Got data for ConnectByClipboard response ' + JSON.stringify(clipboardHandshakeResponse));
                        nConnectionToken = EncryptionService_1.decrypt(clipboardHandshakeResponse.nConnectionToken, cryptoKey);
                        if (nConnectionToken === clipboardHandshakeResponse.ConnectionToken) {
                            this.lastSucceededHandshakeMethod = 'CLIPBOARD';
                            this.companionVersion = clipboardHandshakeResponse.ApplicationVersion;
                            ConnectionPersistenceService_1.setConnectionInfo(this.companionConfig.userID, { connectionToken: clipboardHandshakeResponse.ConnectionToken, cryptoKey: cryptoKey });
                        }
                        else {
                            throw new Error('Clipboard handshake failed on URL ' + this.httpClient.defaults.baseURL + ' due to mismatch in nConnectionToken ');
                        }
                        return [2];
                }
            });
        });
    };
    HttpChannel.prototype.createHttpClient = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var POSSIBLE_PORTS, HTTP_TIMEOUT_IN_MILLI_SEC, DEFAULT_HEADER, i, port, url, config, response, instance, error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        POSSIBLE_PORTS = ['21121', '61176', '51594', '38406', '18675', '63315', '31697', '41767', '37386', '18841'];
                        HTTP_TIMEOUT_IN_MILLI_SEC = 35000;
                        DEFAULT_HEADER = {
                            Accept: 'application/json',
                            'Content-Type': 'application/x-www-form-urlencoded',
                        };
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < POSSIBLE_PORTS.length)) return [3, 6];
                        port = POSSIBLE_PORTS[i];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        this.logger.debug("Trying to connect on port " + port);
                        url = "http://127.0.0.1:" + port + "/workdocs";
                        config = {
                            headers: DEFAULT_HEADER,
                        };
                        return [4, axios_1.default.get(url, config)];
                    case 3:
                        response = _a.sent();
                        this.logger.debug("Pinged port " + port + ", response status: " + response.status);
                        instance = axios_1.default.create({
                            baseURL: url,
                            timeout: HTTP_TIMEOUT_IN_MILLI_SEC,
                            headers: DEFAULT_HEADER,
                        });
                        return [2, instance];
                    case 4:
                        error_3 = _a.sent();
                        if (i === POSSIBLE_PORTS.length - 1) {
                            this.logger.error('Could not establish HTTP connection to any port');
                            throw new Error('Could not establish HTTP connection to any port');
                        }
                        return [3, 5];
                    case 5:
                        i++;
                        return [3, 1];
                    case 6: throw new Error('Error at the end of the createHttpClient()');
                }
            });
        });
    };
    return HttpChannel;
}());
exports.HttpChannel = HttpChannel;
